// removed by extract-text-webpack-plugin
module.exports = {"Picture":"_5R0pZuVAVl07OvIiFrUfe","ImgParent":"_2-1u7GHEKzqV5GpyEL4rNI","Move":"_3XsOjspLJtLF0RUtmRBqar","Name":"_2HemZujZQe3MZHwZzAp9Zl","Tooltip":"_2aabJGeW2gOx3ZcuIjkhL2","Play":"_1bxG2257V3kuIm8Pneb_jr","Logo":"IE7HQfIdXqzgZRI3h0z28","Row":"_1Zpt_VVZ7CRwEFdg-2-3-f","ArticleOption":"_3Zi6wZEEHsNOj6O47uuiTy","Add":"_32hDuED481V9V9CxJa6P1B","Info":"_1zzqZbWCbBYWtMSXtlYApY","Watch":"_2iko3GZG3EEoPwk7tv5LeH","ArticleWatch":"_1tPzbJ6KJ3cX6YOH6kYLpk","NameRef":"_1l3kRilrjp3lHXSUOR_fZ-","Check":"WRw_f1DHoDrjcUjmCRWnd","PlayImage":"_1VNL7lz9_sMgstP7-DXxi2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Picture/Picture.css
// module id = 251
// module chunks = 0